export default class scrollToElement {

  constructor(destination, duration = 200, easing = 'linear', offset = 0, callback) {
    this.duration = duration;
    this.easing = easing;
    this.callback = callback;

    this.easings = {
      linear(t) {
        return t;
      },
      easeInQuad(t) {
        return t * t;
      },
      easeOutQuad(t) {
        return t * (2 - t);
      },
      easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      },
      easeInCubic(t) {
        return t * t * t;
      },
      easeOutCubic(t) {
        return (--t) * t * t + 1;
      },
      easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      },
      easeInQuart(t) {
        return t * t * t * t;
      },
      easeOutQuart(t) {
        return 1 - (--t) * t * t * t;
      },
      easeInOutQuart(t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
      },
      easeInQuint(t) {
        return t * t * t * t * t;
      },
      easeOutQuint(t) {
        return 1 + (--t) * t * t * t * t;
      },
      easeInOutQuint(t) {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
      }
    };

    this.start = window.pageYOffset;
    this.startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.topToScroll = typeof destination === 'number' ? destination : scrollTop + destination.getBoundingClientRect().top;
    if (!(this.topToScroll - offset < 0)) {
      this.topToScroll = this.topToScroll - offset;
    }

    if ('requestAnimationFrame' in window === false) {
      window.scroll(0, this.topToScroll);
      if (this.callback) {
        this.callback();
      }
      return;
    }
    this.scroll();
  }

  scroll = () => {
    const now = 'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, ((now - this.startTime) / this.duration));
    const timeFunction = this.easings[this.easing](time);
    window.scroll(0, Math.ceil((timeFunction * (this.topToScroll - this.start)) + this.start));

    if (Math.ceil(window.pageYOffset) === this.topToScroll) {
      if (this.callback) {
        this.callback();
      }
      return;
    }

    window.requestAnimationFrame(this.scroll);
  }
}


// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ScrollToElement.js